import React from "react";
import Home from "../../assets/icons/Home";
import Business from "../../assets/icons/Business";
import Organization from "../../assets/icons/Organization";
import Sampada from "../../assets/icons/Sampada";
import Emergency from "../../assets/icons/Emergency";

const renderTags = [
  {
    icon: <Home />,
    text: "Home",
  },
  {
    icon: <Business />,
    text: "Business",
  },
  {
    icon: <Organization />,
    text: "Organization",
  },
  {
    icon: <Sampada />,
    text: "Sampada",
  },
  {
    icon: <Emergency />,
    text: "Emergency",
  },
];

const TagCard = ({ icon, text, onClick }) => (
  <div className="rounded-md py-8 sm:py-12 shadow-xl transition-all flex flex-1 min-w-[45%] sm:min-w-[40%] md:min-w-[20%] md:max-w-[23.5%] xl:min-w-[15%] xl:max-w-[18.5%] flex-col justify-center items-center duration-300 ease-in-out hover:bg-[#07A64F] hover:scale-105 backdrop-blur-2xl group group-hover:text-white cursor-pointer">
    <div className="text-[#16A951] group-hover:text-white text-2xl sm:text-3xl">{icon}</div>
    <div className="text-sm sm:text-base font-medium group-hover:text-white mt-4 sm:mt-7">
      {text}
    </div>
  </div>
);

const TagSection = () => {
  const handleTagClick = (tagText) => {
    // Handle tag click as needed
  };
  return (
    <>
      <div></div>
      <div className="flex flex-col items-center  py-20 md:py-28 ">
        <div className="w-full px-4 sm:px-6 xl:px-0 xl:w-2xl ">
          <div
            className="flex flex-col items-center justify-center "
            data-aos="fade-right"
          >
            <div className="font-bold text-3xl md:text-4xl xl:w-1/2 text-center mb-4 ">
              One product, unlimited solutions from KAHA
            </div>
            <div className="font-light text-base text-center  xl:w-[80%] md:mb-16">
              Kaha, as the word describes itself, means “where” in Nepali.
              That's the question we aim to answer. Mostly when people are
              directed to a certain location in Nepal, due to the unnamed
              houses, we often get a call back asking “ya bata kaha ho?” or
              “where is it exactly?”. This is where we introduce Kaha. Kaha is a
              simple solution to location identification which allows
              individuals, businesses, and professionals to tag their specific
              location through KAHA tagging and create a digital identity. The
              unique identity of individuals, businesses, and professionals
              created can be easily shared over this platform and across
              platforms.
            </div>
          </div>

          <div
            className="font-bold text-3xl md:text-4xl  text-center mb-4 mt-10"
            data-aos="fade-left"
          >
            Get KAHA Tag for your Business
          </div>
          <div
            className="font-light text-base text-center"
            data-aos="fade-left"
          >
            Kaha, as the word describes itself, means “where” in Nepali. That's
            the question we aim to answer.
          </div>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mt-8 sm:mt-16" data-aos="zoom-in">
            {" "}
            {renderTags.map((tag) => (
              <TagCard icon={tag.icon} text={tag.text} key={tag.text} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TagSection;
